import '../scss/main.scss';
// import Hero from './components/hero';
import OffreHero from './components/offre-hero';
import Card from './components/card';
import FeatureBlock from './components/feature-block';
import NavBar from './components/navbar';
import MobileMenu from './components/mobile-menu';
import AccessRapid from './components/access-rapid';
import NewsSection from './components/news-section';
import PushActs from './components/push-actualites';
import DataTableSwiper from './components/data-table-swiper';
import { initPushImages } from './components/push-images';
import Animations from './animations';
import Faq from './components/faq';
import FullWidthFaq from './components/full-width-faq';
import Outils from './components/outils';
import ServicesCards from './components/services-cards';
import Shortcut from './components/shortcut';
import SecondaryServicesCards from './components/secondary-services-cards';
import TestimonialsSlider from './components/testimonials-slider';
import HeroSearch from './components/hero-search';
import AutoSubmit from './components/auto-submit';
import SearchAutocomplete from './components/search-autocomplete';
import initStoriesSlider from './components/stories-slider';
import ContentPortrait from './components/content-portrait';
import PopUp from './components/pop-up';
import BoutonOverflow from './components/bouton-overflow';
import ContactPopup from './components/contact-popup';
import PlyrVideo from './components/plyr-video';
import Tunnel from './components/tunnel';
import ContactServices from './components/contact-services.js';
import ContactAgence from './components/contact-agence.js';
import Newsletter from './components/newsletter.js';

class Main {
  constructor(settings = {}) {
    this.init();
  }

  /**
   * Initialization of all modules
   */
  initModules() {
    // Hero.init();
    Card.init();
    FeatureBlock.init();
    NavBar.init();
    MobileMenu.init();
    AccessRapid.init();
    NewsSection.init();
    PushActs.init();
    initPushImages();
    Animations.init();
    Faq.init();
    FullWidthFaq.init();
    Outils.init();
    ServicesCards.init();
    Shortcut.init();
    SecondaryServicesCards.init();
    TestimonialsSlider.init();
    HeroSearch.init();
    DataTableSwiper.init();
    AutoSubmit.init();
    SearchAutocomplete.init();
    initStoriesSlider.init();
    ContentPortrait.init();
    PopUp.init();
    BoutonOverflow.init();
    ContactPopup.init();
    PlyrVideo.init();
    Tunnel.init();
    ContactServices.init();
    ContactAgence.init();
    OffreHero.init();
    Newsletter.init();
  }

  /**
   * Initialization
   */
  init() {

    window.addEventListener('DOMContentLoaded', () => {
      this.initModules();
    });

    window.addEventListener('scroll', () => {
      //
    });
  }
}

new Main();
